<template lang="pug">
  main
    NavBarSca
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Entradas Cargas
        .columns
          .column.is-3
            label.label Fecha de Jornada:
            .field
              .control
                flat-pickr(
                  v-model='fechaJornada'
                  :config="config"
                  class="input"
                )
          .column.is-1
            .field
              a.button.is-text.is-rounded(@click="iniciarComponente")
                | Actualizar
          .column.is-1
            .field
              a.button.is-primary.is-rounded(v-if="solicitudes.length == 0" @click="enviarSolicitudCargas")
                | Obtener Cargas Faltantes
              a.button.is-text(v-else)
                | Cargas Pendientes solicitadas &nbsp
                span.icon
                  i.fas.fa-envelope
          .column.is-offset-3.is-3
            .field
              label.label Filtrar
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='🔎 Buscar por PG | Folio | Llenadera',
                  v-model="query_filter",
                )
        .columns
          .column.is-offset-3.is-6
            .columns.has-text-centered
              .column.is-12
                span.is-size-5 
                  strong  Cargas Diarias
            .columns.has-text-centered
              .column.is-12
                TbListasCargas(:entradas="tanksCargas_show" @updateTbListasCargas="updListCargas")
</template>

<script>
  import NavBarSca from '@/components/sca_Componentes/layout/tpa/NavBarSca.vue'
  import sca_tuxpanServices from '@/services/sca/tpa.js'
  import api_cargas_tpa from '../../../services/sca/apiCargasTpa'
  import Loader from '@/components/shared/Loader.vue'
  import TbListEntradas from '@/components/sca_Componentes/componentes/TbListEntradas.vue'
  import TbListEnServicio from '@/components/sca_Componentes/componentes/TbListEnServicio.vue'
  import TbListasCargas from '@/components/sca_Componentes/componentes/TbListasCargas.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { mapState } from 'vuex'
  import moment from 'moment'
  
  export default {
    name: 'EntradasTPA',
    components: { NavBarSca, Loader, flatPickr, TbListEntradas, TbListEnServicio, TbListasCargas },
    data() {
      return {
        isLoading: true,
        fechaJornada: moment().format('YYYY-MM-DD'),
        query_filter: '',
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        entList: [],
        entList_show: [],
        tanksInService: [],
        tanksInService_show: [],
        tanksCargas: [],
        tanksCargas_show: [],
        solicitudes: [],
      }
    },
    watch: {
      fechaJornada() {
        this.obtenerCargas()
      },
      query_filter () {
        const tkFilterCarga = this.tanksCargas.filter( carga => { 
        return `${carga.pg} ${carga.folioCarga} ${carga.llenadera}`.toUpperCase().includes(this.query_filter)
        }) 
        this.tanksCargas_show = tkFilterCarga
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerCargas() 
        this.obtenerSolicitudes()
      },
      /* obtenerEntradasLista() {
        this.isLoading = true
        sca_tuxpanServices.getEntryList(this.fechaJornada)
          .then( resp => {
            console.log(resp)
            this.entList = resp
            this.entList_show = this.entList
            this.isLoading = false
          })
          .catch(e => {
            console.log(e)
            this.isLoading = false
          })
          this.obtenerTanquesServicio()
      },
      obtenerTanquesServicio() {
        this.isLoading = true
        sca_tuxpanServices.getTanksInService(this.fechaJornada)
          .then( resp => {
            console.log(resp)
            this.tanksInService = resp
            this.tanksInService_show = this.tanksInService
            this.isLoading = false
          })
          .catch(e => {
            console.log(e)
            this.isLoading = false
          })
          this.obtenerCargas()
      }, */
      obtenerCargas() {
        this.isLoading = true
        const fecha = moment(this.fechaJornada).format('YYYY-MM-DD')
        const obj = { fecha }
        api_cargas_tpa.getCargasTPA(obj)
          .then( resp => {
            console.log(resp)
            this.tanksCargas = resp.data
            this.tanksCargas_show = this.tanksCargas
            this.isLoading = false
          })
          .catch(e => {
            console.log(e)
            this.isLoading = false
          })
      },

      obtenerCargasPerdidas() {
        this.isLoading = true
        const fecha = moment(this.fechaJornada).format('YYYY-MM-DD')
        const obj = { fecha }
        api_cargas_tpa.getCargasFaltantesTPA(obj)
        .then( resp => {
          this.$toasted.show(resp.message, { 
            theme: 'bubble', 
            position: "bottom-right", 
            duration : 3000,
            iconPack: 'fontawesome',
            icon: 'done',
            action : {
              text : 'OK',
              onClick : (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
          })
          this.isLoading = false
        })
        .catch(e => {
            console.log(e)
            this.isLoading = false
        })
      },
      
      updListEntradas () {
        this.obtenerEntradasLista()
      },
      updListServicio () {
        this.obtenerTanquesServicio()
      },
      updListCargas () {
        this.obtenerCargas()
      },

      obtenerSolicitudes() {
        console.log(2)
        sca_tuxpanServices.getSolicitudCargasPendientes()
          .then( resp => {
            console.log(resp)
            this.solicitudes = resp
          })
          .catch(e => {
            console.log(e)
          })
      },

      enviarSolicitudCargas() {
        console.log('Enviar Solicitud')
        console.log("🚀 ~ file: EntradasTPA.vue:202 ~ enviarSolicitudCargas ~ this.userLogin.id:", this.userLogin.id)
        sca_tuxpanServices.insertSolicitudCargasPendientes(this.userLogin.id)
        
          .then( resp => {
            console.log(resp)
            this.solicitudes = resp
            this.displayToast('success','Solicitud de Obtener Cargas Enviada', 'done', 'OK', null)
            this.obtenerSolicitudes()
          })
          .catch(e => {
            console.log(e)
          })
      },

      aceptarSolicitudCargas() {
        console.log('Aceptar Solicitud')

        if (this.permisos.sca_tpa == 5) {
          const solicitud = this.solicitudes[0]
          sca_tuxpanServices.updateSolicitudCargasPendientes(solicitud.id)
            .then( resp => {
              console.log(resp)
              this.solicitudes = resp
              this.displayToast('success','La solicitud ha sido aceptada', 'done', 'OK', null)
              this.obtenerCargasPerdidas()
              this.obtenerSolicitudes()
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          this.displayToast('error','Debe ser un usuario de cuarto de control ', 'ban', 'OK', null)
        }

      },

      displayToast(type, message, icon, actionText, destiny) {
        const toast = this.$toasted.show(message, { 
          theme: type === 'success'? "toasted-primary" : "bubble", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              console.log(destiny)
              this.$router.push(destiny)
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos'])
    }
  }
</script>

<style lang="css" scoped>
  .container {
    width: 95%;
    max-width: 95%;
  }
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/EntradasTPA.vue